import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  AEMErrorMessagesSection,
  AEMFeatureFlags,
  CommonConstants,
  EndpointKeys,
  IDP_APPS,
  Libraries
} from '@com-delta-idp/mnx-skymiles-shared';
import {
  ApiBuilder,
  AppConfigService,
  HttpRequestMethods,
  handleError
} from '@com-delta-idp/mnx-utils';

import { Observable } from 'rxjs';
import { AEMContent, AEMWelcomeTour, Features } from '../../models';
import { AEMOverview } from '../../models/aem/overview.interface';

@Injectable({
  providedIn: 'root'
})
export class ContentService {
  errorHandler = handleError.bind(this);

  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService
  ) {}

  getContent = (): Observable<AEMContent> =>
    new ApiBuilder<undefined, AEMContent>(this.http, this.appConfig)
      .app(IDP_APPS.SKYMILES)
      .endpointKey(EndpointKeys['SKYMILES_AEM_OVERVIEW_CONTENT'])
      .method(HttpRequestMethods['GET'])
      .timeOut(CommonConstants.TIMEOUT)
      .errorHandler(this.errorHandler)
      .library(Libraries.OVERVIEW)
      .create();

  getSummaryContent = (): Observable<AEMOverview> =>
    new ApiBuilder<undefined, AEMOverview>(this.http, this.appConfig)
      .app(IDP_APPS.SKYMILES)
      .endpointKey(EndpointKeys['SKYMILES_AEM_OVERVIEW_MAIN_CONTENT'])
      .method(HttpRequestMethods['GET'])
      .timeOut(CommonConstants.TIMEOUT)
      .errorHandler(this.errorHandler)
      .library(Libraries.OVERVIEW)
      .create();

  getFeatureFlags = (): Observable<AEMFeatureFlags<Features>> =>
    new ApiBuilder<undefined, AEMFeatureFlags<Features>>(
      this.http,
      this.appConfig
    )
      .app(IDP_APPS.SKYMILES)
      .endpointKey(EndpointKeys['SKYMILES_AEM_OVERVIEW_FEATURE_FLAGS'])
      .method(HttpRequestMethods['GET'])
      .timeOut(CommonConstants.TIMEOUT)
      .errorHandler(this.errorHandler)
      .library(Libraries.OVERVIEW)
      .create();

  getWelcomeTour = (): Observable<AEMWelcomeTour> =>
    new ApiBuilder<undefined, AEMWelcomeTour>(this.http, this.appConfig)
      .app(IDP_APPS.SKYMILES)
      .endpointKey(EndpointKeys['SKYMILES_AEM_OVERVIEW_WELCOME_TOUR'])
      .method(HttpRequestMethods['GET'])
      .timeOut(CommonConstants.TIMEOUT)
      .errorHandler(this.errorHandler)
      .library(Libraries.OVERVIEW)
      .create();

  getErrorMessages = (): Observable<AEMErrorMessagesSection> =>
    new ApiBuilder<undefined, AEMErrorMessagesSection>(
      this.http,
      this.appConfig
    )
      .app(IDP_APPS.SKYMILES)
      .endpointKey(EndpointKeys['SKYMILES_AEM_OVERVIEW_ERROR_MESSAGES'])
      .method(HttpRequestMethods['GET'])
      .timeOut(CommonConstants.TIMEOUT)
      .errorHandler(this.errorHandler)
      .library(Libraries.OVERVIEW)
      .create();
}
